import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@mui/material'
import {
  Home as ApiaryIcon,
  Hive as HiveIcon,
  Assignment as InspectionIcon,
  Checklist as ChecklistIcon,
  NotificationsActive as AlertRuleIcon,
  Dashboard as DashboardIcon,
  Group as GroupIcon,
} from '@mui/icons-material'

interface PlusMenuProps {
  anchorEl: null | HTMLElement
  open: boolean
  onClose: () => void
}

const PlusMenu: React.FC<PlusMenuProps> = ({ anchorEl, open, onClose }) => {
  const navigate = useNavigate()

  const handleNavigation = (path: string) => {
    navigate(path)
    onClose()
  }

  const menuItems = [
    {
      title: 'New Apiary',
      icon: <ApiaryIcon />,
      path: '/apiaries/create',
    },
    {
      title: 'New Hive',
      icon: <HiveIcon />,
      path: '/hives/create',
    },
    {
      title: 'New Inspection',
      icon: <InspectionIcon />,
      path: '/inspections/create',
    },
    {
      title: 'New Checklist',
      icon: <ChecklistIcon />,
      path: '/checklists/create',
    },
    {
      title: 'New Alert Rule',
      icon: <AlertRuleIcon />,
      path: '/alertrules/create',
    },
    {
      title: 'New Dashboard',
      icon: <DashboardIcon />,
      path: '/dashboards/create',
    },
    {
      title: 'New Group',
      icon: <GroupIcon />,
      path: '/groups/create',
    },
  ]

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      PaperProps={{
        sx: {
          minWidth: 200,
          mt: 1,
        },
      }}
    >
      {menuItems.map((item, index) => (
        <div key={item.title}>
          <MenuItem onClick={() => handleNavigation(item.path)}>
            <ListItemIcon sx={{ color: 'secondary.main' }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.title} />
          </MenuItem>
          {index === 3 && <Divider />}
        </div>
      ))}
    </Menu>
  )
}

export default PlusMenu
